import React from "react";
import dynamic from "next/dynamic";
import { FormattedMessage } from "react-intl";

const BreadCrumb = dynamic(
  () => import("src/components/shared/breadCrumb/Index.js"),
);
const PageHeader = dynamic(
  () => import("src/components/shared/PageHeader/PageHeader"),
);
const Footer = dynamic(() => import("src/components/shared/Footer/Footer"));

import styles from "./OurworksPage.module.scss";
import Image from "next/future/image";
import { Col, Container, Row } from "react-bootstrap";
import { useRouter } from "next/router";

import ReactBeforeSliderComponent from "react-before-after-slider-component";
import { buildApiUrl } from "src/helpers/imageHelpers";
import "react-before-after-slider-component/dist/build.css";
import grapperIcon from "../../../public/logo.png";
import CommonQuestions from "src/components/shared/CommonQuestions/CommonQuestions";
const OurworksPage = ({ data }) => {
  const { locale } = useRouter();

  const galleryPosts = data?.galleryData?.[0]?.categories?.[0]?.posts;
  const questionsData = data?.questions?.[0]?.categories?.[0]?.posts;

  const targetQuestion = questionsData?.find((question) => question.id === 418);
  const commonQuestionsBackgroundImage = targetQuestion?.data?.image;
  const filteredQuestions = questionsData?.filter(
    (question) => question.id !== 418,
  );

  return (
    <div>
      <PageHeader />
      <BreadCrumb title={<FormattedMessage id="our-works" />} />
      <Container>
        <div
          className={styles["our-works"]}
          dir={locale === "ar" ? "rtl" : "ltr"}
        >
          <Row className="gy-4">
            {galleryPosts?.map((post, index) => {
              return (
                <Col xs={12} sm={6} key={index}>
                  <div className="work-item">
                    <div className="content">
                      <ReactBeforeSliderComponent
                        firstImage={{
                          imageUrl: buildApiUrl(post?.data?.image),
                          alt: post?.data?.imageMeta || "work-image",
                        }}
                        secondImage={{
                          imageUrl: buildApiUrl(post?.data?.image_new),
                          alt: post?.data?.imageMeta_new || "work-image",
                        }}
                        delimiterIconStyles={{
                          width: "70px",
                          height: "70px",
                          backgroundImage: `url(${grapperIcon.src})`,
                          backgroundPosition: "center",
                          backgroundSize: "45px",
                          backgroundRepeat: "no-repeat",
                          border: "2px solid #ea0000",
                        }}
                      />
                      {/* {post?.data?.image ? (
                      <Image
                        src={`${process.env.NEXT_PUBLIC_API_URL}${post?.data?.image}`}
                        alt={post?.data?.imageMeta || "work-image"}
                        sizes="(max-width: 600px) 100vw, (max-width: 1200px) 50vw, 33vw"
                        quality={100}
                       
                        priority
                        width={700}
                        height={500}
                      />
                    ) : (
                      <div
                        aria-hidden="true"
                        style={{
                          width: "100%",
                          height: "100%",
                          backgroundColor: "#f0f0f0",
                        }}
                      />
                    )} */}
                    </div>
                    <div className="desc">
                      <h3>{post?.data?.title?.[locale]}</h3>
                    </div>
                  </div>
                </Col>
              );
            })}
          </Row>
        </div>
      </Container>
      <CommonQuestions
        commonQuestionsBackgroundImage={commonQuestionsBackgroundImage}
        filteredQuestions={filteredQuestions}
      />
      <Footer />
    </div>
  );
};

export default OurworksPage;
